// Core Modules
import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';

// External Modules
import { NgxPermissionsModule } from 'ngx-permissions';

// Services
import { ConfigService } from '@core/services/config/config.service';

// Models
import { MenuContentModel } from '@shared/models/main-navigation-content.model';

@Component({
  selector: 'app-main-navigation',
  standalone: true,
  imports: [CommonModule, NgxPermissionsModule, RouterModule],
  templateUrl: './main-navigation.component.html',
  styleUrl: './main-navigation.component.scss',
})
export class MainNavigationComponent {
  // Injectors
  private readonly configService = inject(ConfigService);

  // Public Members
  public readonly menu: MenuContentModel[] = [];

  constructor() {
    // Load this component's static contents from app-contents.json file
    this.menu = this.configService.getContents('mainNavigation')?.menu || [];
  }

  public navigateToRoute(path: string): void {
    // Below flag is required to keep track of which route is triggered when user is having unsaved audience changes
    // When click on Save Button from Audience Settings popup window (with unsaved warning message), redirecting to below route.
    if (sessionStorage.getItem('save_audience') === 'true') {
      sessionStorage.setItem('next_state', path);
    }
  }
}
